import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';

  export default class GeneralParamsApplications extends Component{ 

    constructor(props){
      super(props);

      this.state={
          applications:[],
          modalTitle:"",
          applicationname:"",
          applicationid:0,

          ApplicationIdFilter:"",
          ApplicationNameFilter:"",
          applicationsWithoutFilter:[],
          applicationNames: [],
          applicationExists: false,
          uniqueApplicationIdsProducts:[],
      }
  }

  FilterFn(){
    var ApplicationIdFilter=this.state.ApplicationIdFilter;
    var ApplicationNameFilter = this.state.ApplicationNameFilter;

    var filteredData=this.state.applicationsWithoutFilter.filter(
        function(el){
            return el.applicationid.toString().toLowerCase().includes(
                ApplicationIdFilter.toString().trim().toLowerCase()
            )&&
            el.applicationname.toString().toLowerCase().includes(
                ApplicationNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({applications:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.applicationsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({applications:sortedData});

}

changeApplicationIdFilter = (e)=>{
  this.state.ApplicationIdFilter=e.target.value;
  this.FilterFn();
}
changeApplicationNameFilter = (e)=>{
  this.state.ApplicationNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/applications/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({applications:data,applicationsWithoutFilter:data});
  });
}


fetchApplicationNames() {
  axiosService.get('/applications/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const applicationNames = data.map(item => item.applicationname);
      this.setState({ applicationNames: applicationNames });
    })
    .catch(error => {
      console.error("Error fetching application names:", error);
    });
}

checkApplicationExists = (event) => {
  const enteredApplication = event.target.value.toLowerCase(); // Convert to lowercase
  const { applicationNames } = this.state;
  const applicationExists = applicationNames.some((application) => application.toLowerCase() === enteredApplication);
  this.setState({ applicationExists });
};

fetchApplicationIdsProducts() {
  axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueApplicationIdsProducts = [...new Set(data.map((item) => item.applicationid))];
      this.setState({ uniqueApplicationIdsProducts: uniqueApplicationIdsProducts });
    })
    .catch((error) => {
      console.error('Error fetching Products data:', error);
    });
}


componentDidMount(){
  this.refreshList();
  this.fetchApplicationNames();
  this.fetchApplicationIdsProducts();
}

changeApplicationName =(e)=>{
  this.setState({applicationname:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add Application",
      applicationid:0,
      applicationname: "",
      applicationExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit Application",
      applicationid:dep.applicationid,
      applicationname:dep.applicationname,
      intitialApplicationname:dep.applicationname,
      applicationExists: false,
  });
}

createClick() {
  const { applicationname, applicationNames } = this.state;

  if (!applicationname) {
    alert('Application Name is required');
    return;
  }

  if (applicationNames.some(name => name.toLowerCase() === applicationname.toLowerCase())) {
    alert('Application already exists. Please provide a unique Application Name.');
    return;
  }

  axiosService.post('/applications/', {
    applicationname: applicationname
  })
    .then(result => {
      alert('Application created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { applicationname, intitialApplicationname, applicationNames } = this.state;

   // Check if any changes are detected
   if (
    applicationname === intitialApplicationname
  ) {
    alert('No changes detected');
    return;
  }

  if (!applicationname) {
    alert('Application Name is required');
    return;
  }
  
  if (
    applicationNames.some(
      (existingApplication) =>
        existingApplication.toLowerCase() === applicationname.toLowerCase()
    )
  ) {
    alert('Application already exists. Please provide a unique Application Name.');
    return;
  }

  axiosService.patch('/applications/'+id+'/',{
      applicationid:this.state.applicationid,
      applicationname:this.state.applicationname
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  },(error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (this.state.uniqueApplicationIdsProducts.includes(id)) {
    alert('Cannot delete this Application as it is in the Products Table !');
    return; // Exit the function without making the delete request
  }

  if (window.confirm('Are you sure?')) {
    axiosService.delete('/applications/' + id + '/')
      .then(() => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      applications,
      modalTitle,
      applicationid,
      applicationname,
      applicationExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>

  Add Application
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeApplicationIdFilter}
      placeholder="Filter"/>

      </div>
      ApplicationId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeApplicationNameFilter}
      placeholder="Filter"/>

      </div>
      Application

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {applications.map(dep=>
      <tr key={dep.applicationid}  className="row-hover">
          <td className="table-text">{dep.applicationid}</td>
          <td className="table-text">{dep.applicationname}</td>
          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.applicationid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>
          </div>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Application</span>
          <input
            type="text"
            className={`form-control ${applicationExists ? "is-invalid" : ""}`}
            value={applicationname}
            onChange={this.changeApplicationName}
            onBlur={this.checkApplicationExists} 
            style={{ fontSize: "12px" }} 
          />
          {applicationExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Application already exists.</div>}
        </div>

        {applicationid === 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {applicationid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.updateClick(applicationid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }